import React from 'react';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import StarIcon from '@mui/icons-material/Star';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { FadeIn } from './FadeIn';
import { SectionHeader } from './SectionHeader';
import { TestimonialAd } from './TestimonialAd';
import { SocialProofAd } from './SocialProofAd';
import { ResultsStrip } from './ResultsStrip';
import { AnimatedBackground } from './AnimatedBackground';
import { TestimonialCarousel } from './TestimonialCarousel';
import { ProofMarquee } from './ProofMarquee';
import { TiltCard } from './motion/TiltCard';
import { LazyMount } from './motion/LazyMount';
import { scrollToForm } from '../utils/scroll';
function AdPlaceholder() {
  return <div className="aspect-square w-full rounded-2xl border-2 border-line bg-white/70" data-id="element-402" data-mp="2s3jh08b0gqlr" />;
}
export function Testimonials() {
  return <section id="testimonios" className="cv-auto relative w-full overflow-hidden bg-mist px-6 py-24" data-id="element-403" data-mp="qalibvujz3sw">
      <AnimatedBackground intensity="light" icons data-id="element-404" data-mp="h5or9fhq4e9j" />

      <div className="relative mx-auto max-w-[1100px]" data-id="element-405" data-mp="h8181pbqwil0">
        <FadeIn data-id="element-406" data-mp="m62o01dvk1s9">
          <SectionHeader centered badge="Testimonios" badgeIcon={<StarOutlineIcon sx={{
          fontSize: 15
        }} data-id="element-408" data-mp="7926srtb7p81" />} title={<>
                Negocios reales.
                <br data-id="element-409" data-mp="c8y11zc7g2ae" />
                Resultados reales.
              </>} subtitle="Más de 100 dueños de negocio ya tienen su web con nosotros. Esto es lo que pasó después." data-id="element-407" data-mp="m6m91qytn6ai" />
        </FadeIn>

        <FadeIn data-id="element-410" data-mp="q6mpfh5hdrk7">
          <ResultsStrip data-id="element-411" data-mp="q761wicd3nqu" />
        </FadeIn>

        <FadeIn delay={0.05} data-id="element-412" data-mp="q6cv5hdeky8p">
          <div className="mt-14" data-id="element-413" data-mp="v5pqyrm95fnf">
            <TestimonialCarousel data-id="element-414" data-mp="v4o47pvvj4pv" />
          </div>
        </FadeIn>

        <FadeIn data-id="element-415" data-mp="1iva9j9ehuaw6">
          <div className="mt-14" data-id="element-416" data-mp="1ius71v18n0ft">
            <ProofMarquee data-id="element-417" data-mp="1itqwrss1qhz5" />
          </div>
        </FadeIn>

        <div className="mt-16 grid grid-cols-1 items-start gap-8 lg:grid-cols-2" data-id="element-418" data-mp="1nmk1whrffsbr">
          <FadeIn direction="right" data-id="element-419" data-mp="1xi0r7lciyg3x">
            <LazyMount placeholder={<AdPlaceholder data-id="element-421" data-mp="1xh7qb108yktp" />} data-id="element-420" data-mp="1xgxyr8zk05lw">
              <TiltCard intensity={6} className="rounded-2xl" data-id="element-422" data-mp="1siwewlub029d">
                <TestimonialAd data-id="element-423" data-mp="1sjpe91qxnphh" />
              </TiltCard>
            </LazyMount>
            <p className="mt-3 text-center text-xs font-medium text-muted" data-id="element-424" data-mp="1ofzsek1n7m05">
              Caso real · Pieza 1080 × 1080 lista para Instagram y Facebook.
            </p>
          </FadeIn>

          <FadeIn direction="left" delay={0.08} data-id="element-425" data-mp="1ek6iz9j808ml">
            <LazyMount placeholder={<AdPlaceholder data-id="element-427" data-mp="19sofoetq5vyg" />} data-id="element-426" data-mp="1ekzhjn80zrtn">
              <TiltCard intensity={6} className="rounded-2xl" data-id="element-428" data-mp="19rdbidwdam6t">
                <SocialProofAd data-id="element-429" data-mp="14t22u6ht6hq6" />
              </TiltCard>
            </LazyMount>
            <p className="mt-3 text-center text-xs font-medium text-muted" data-id="element-430" data-mp="14qz32uquta89">
              Prueba social · Pieza 1080 × 1080 lista para Instagram y Facebook.
            </p>
          </FadeIn>
        </div>

        <FadeIn data-id="element-431" data-mp="qtkaxi97uocl">
          <div className="mt-14 flex flex-col items-center gap-4 rounded-2xl border-2 border-brand-blue/15 bg-white px-8 py-8 text-center shadow-card sm:flex-row sm:justify-between sm:text-left" data-id="element-432" data-mp="qt0rfx3x3rwg">
            <div data-id="element-433" data-mp="37fqqfr7i8j1a">
              <p className="flex items-center justify-center gap-1.5 text-sm font-bold text-ink sm:justify-start" data-id="element-434" data-mp="37f7dkowpoku4">
                <span className="flex gap-0.5 text-brand-yellow" aria-label="4.9 de 5 estrellas" data-id="element-435" data-mp="3cgemwsei5s2w">
                  {Array.from({
                  length: 5
                }).map((_, index) => <StarIcon key={index} sx={{
                  fontSize: 16
                }} data-id="element-436" data-mp="2js91e3fmjz20" data-mpi={index} />)}
                </span>
                4.9 / 5 de calificación promedio
              </p>
              <p className="mt-1 text-sm text-muted" data-id="element-437" data-mp="2sqayw905g9kj">
                Negocios de 12 estados ya reciben clientes desde su web.
              </p>
            </div>
            <button type="button" onClick={scrollToForm} className="group relative inline-flex flex-shrink-0 items-center gap-2 overflow-hidden rounded-full bg-brand-yellow px-6 py-3 font-display text-sm font-extrabold text-brand-deep transition hover:-translate-y-0.5 hover:shadow-glow focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue focus-visible:ring-offset-2" data-id="element-438" data-mp="2106h8i3ry0n0">
              <span aria-hidden="true" className="absolute inset-y-0 -left-1/3 w-1/3 skew-x-12 bg-white/50 blur-md transition-transform duration-700 group-hover:translate-x-[420%]" data-id="element-439" data-mp="1vnhw8bghhbf5" />
              <RocketLaunchIcon sx={{
              fontSize: 18
            }} data-id="element-440" data-mp="24phdn4veuhim" />
              Quiero mis resultados
            </button>
          </div>
        </FadeIn>
      </div>
    </section>;
}